import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class KycStatusService {
  private statusSource = new Subject<void>();
  statusChanged$ = this.statusSource.asObservable();
  private nomineeUpdatedSource = new Subject<void>();
  nomineeUpdated$ = this.nomineeUpdatedSource.asObservable();

  notifyStatusChange() {
    this.statusSource.next();
  }

  notifyNomineeUpdated() {
    this.nomineeUpdatedSource.next();
  }
}
